/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { EntityList } from "./EntityList";
/**
 * <pre><code>Map containing EntityFilter to corresponding EntitiesList
 * entityFilter: Represents filter used to group the entities
 * entityList: Represent the list of entities corresponding to the EntityFilter
 * <\/code><\/pre>
 **/
export class EntityFilterToEntityListMap {
    constructor(options) {
        for (const key of Object.keys(options)) {
            this[key] = options[key];
        }
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data)) {
            obj[key] = EntityList.fromJson(data[key]);
        }
        return new EntityFilterToEntityListMap(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map)) {
            data[key] = EntityList.toJson(map[key]);
        }
        return data;
    }
}
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityFilterToEntityListMap] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateEntityfiltertoentitylistmap(data) {
    // TODO: Actually implement this!
    return data;
}
